import type { GridColDef } from '@mui/x-data-grid-pro';

// Grid column type for a variable's uppercased data type label, mirroring the
// types the server gives the real result columns so a placeholder header sorts
// and filters the same way. Other formats stay untyped, as on the server.
const PLACEHOLDER_TYPE_BY_LABEL: Record<string, GridColDef['type']> = {
  DATE: 'date',
  DATETIME: 'dateTime',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
};

export const toPlaceholderColumnType = (typeLabel: string | null): GridColDef['type'] =>
  typeLabel ? PLACEHOLDER_TYPE_BY_LABEL[typeLabel.toUpperCase()] : undefined;
